import React, { useEffect, useState } from "react";
import { useParams, Link } from 'react-router-dom';
import configVars from "../../config";
//import {setWithExpiry } from '../../common';
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import { getWithExpiry } from '../../common';

const OrganizationMembers = (props) => {

    const { organization_id, method, team_id } = useParams();
    const [organizationUsers, setOrganizationUsers] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [currentUser, setCurrentUser] = useState(0);
    const [translation] = useTranslation("translations");
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [deleteConfirmation, setDeleteConfirmation] = useState(false);
    const [canUserEdit, setCanUserEdit] = useState(false);
    const [hideLoadMore, setHideLoadMore] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [timer, setTimer] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    // const [searchResults, setSearchResults] = useState([]);

    useEffect(() => {

        if ( props?.members ) {
            setOrganizationUsers( props?.members );
        }

        const hasAccessToEdit = getWithExpiry('can_user_edit');

        if ( hasAccessToEdit === true ) {
            setCanUserEdit(true);
        }

    }, [props]);


    const handleMemberDelete = async ( userID ) => {
        
        setIsSaving( true );
        setCurrentUser( userID );

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'organization_id', organization_id );
            userRequestData.append( 'user_id', userID );

            if ( team_id ) {
                userRequestData.append( 'team_id', team_id );
            }

            if ( props?.type && props?.type === 'managers' &&  method === 'managers' ) {
                userRequestData.append( 'delete_type', 'manager' );
            }

            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/removeorgmember/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const teamResponse = await response.json();
        
                if ( teamResponse ) {
                    
                    //console.log( teamResponse );

                    if ( teamResponse.success === true ) {
                        localStorage.removeItem( `sy_org_${organization_id}_data` );
                        window.location.reload();
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setIsSaving( false );
            setCurrentUser(0);
    
        
        // if ( companyResponse ) {
        //     //console.log( companyResponse );

        //     if ( companyResponse.success === true ) {
        //         setOrganizationUsers( companyResponse.data.users );

        //         setWithExpiry( `sy_org_${organization_id}_data`, companyResponse.data );

        //     }

        //     setIsSaving( false );
        //     setCurrentUser(0);
        // }

    }

    const handleLoadMore = async () => {

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'organization_id', organization_id );
            userRequestData.append( 'curr_num', organizationUsers.length );

            setIsSaving(true);

            const currentUsers = organizationUsers;


            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/loadmoreorgusers/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {

                    if ( userResponse.success === true ) {
                        if ( userResponse.data.users && userResponse.data.users.length > 0 ) {
                            setOrganizationUsers( currentUsers.concat( userResponse.data.users ) )
                        }
                    }

                    if ( userResponse.message === 'no-more-posts' ) {
                        setHideLoadMore(true);
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setIsSaving(false);
       
    }

    const handleMemberSearch = ( query ) => {

        setSearchQuery(query);

        clearTimeout(timer);

        if ( !query || query.length < 2 ) {
            setIsSearching(false);
            setOrganizationUsers(props?.members);
            setHideLoadMore(false);
            return;
        }

        const newTimer = setTimeout( async () => {
            
            let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'organization_id', organization_id );
            userRequestData.append( 'query', query );

            setIsSearching(true);


            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/searchorgusers/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {

                    if ( userResponse.data.found_users && userResponse.data.found_users.length > 0 ) {
                        setOrganizationUsers(  userResponse.data.found_users );
                        setHideLoadMore(true);
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }
            
            setIsSearching(false);

        }, 1000)

        setTimer(newTimer)

        

    }

    const handleManager = async (isManager, userID) => {
        
        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'organization_id', organization_id );
            userRequestData.append( 'is_manager', !isManager );
            userRequestData.append( 'user_id', userID );

            setIsSaving(true);
            setCurrentUser( userID );


            const fetchUrl = `${configVars.apiUrl}sustainchange/v1/addremoveorgmanager/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const userResponse = await response.json();
        
                if ( userResponse ) {

                    console.log( userResponse );

                    if ( userResponse.success === true ) {
                        localStorage.removeItem( `sy_org_${organization_id}_data` );
                        window.location.reload();
                    }

                }

            } catch( error ) {
                console.log( error );
                return error;
            }

            setIsSaving(false);
            setCurrentUser( 0 );

    }

    return (
        <div className="organization-members" >

            <div className="row mt-4 justify-content-end">

                {((props?.membersCount && props?.membersCount > 12) || (team_id && team_id === 'edit')) &&
                    <div className="col-12 col-lg">
                        <input type="text" className="form-control ms-2 bg-white rounded-pill" placeholder="Sök medlemmar..." value={searchQuery} onChange={(e) => handleMemberSearch(e.target.value)}  />
                    </div>
                }
                {isSearching &&
                    <div className="col-12 col-lg-auto">
                        <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                }
                {canUserEdit &&
                    <div className="col-12 col-lg-auto d-flex justify-content-end">
                        <Link to={`/organizations/${organization_id}/new-member`} className="btn btn-primary float-lg-end mt-4 mt-lg-0 text-white rounded-pill" >
                            <span className="pe-2">{translation("add_new_member")}</span>
                            <i className="fa fa-plus" aria-hidden="true"></i>
                        </Link>
                    </div>
                }
            </div>
            
            {organizationUsers && organizationUsers.length > 0 &&
                <div className="row mt-5">
                    { organizationUsers.map( ( user, index ) => {
                        return(
                            <div className="col-12 col-md-6 col-lg-3 mb-4 position-relative" key={index}>
                                <div className="card border-0 shadow pt-3 h-100">
                                    {user.avatar && (!deleteConfirmation || currentUser !== user.id) &&
                                        <img src={user.avatar} className="card-img-top rounded-circle d-block mx-auto" alt={user.name} style={{ maxWidth: "120px" }} />
                                    }
                                    <div className="card-body">
                                        
                                        {(!deleteConfirmation || currentUser !== user.id) &&
                                            <h4 className="card-title text-center">{user.name}</h4>
                                        }

                                        {(!deleteConfirmation || currentUser !== user.id) && canUserEdit &&
                                            <span className="text-center d-inline-block w-100 opacity-half font-size-medium">{user.email}</span>
                                        }

                                        {(!deleteConfirmation || currentUser !== user.id) && user.last_login && canUserEdit &&
                                            <span className="text-center d-inline-block w-100 opacity-half font-size-medium">Senaste inloggning: {user.last_login} sedan</span>
                                        }
                                        
                                        {deleteConfirmation && currentUser === user.id && 
                                            <div className="toast show" role="alert" aria-live="assertive" aria-atomic="true">
                                                <div className="toast-header">
                                                    <strong className="me-auto">Are you sure?</strong>
                                                    <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" onClick={() => setDeleteConfirmation(false)}></button>
                                                </div>
                                                <div className="toast-body">
                                                    If you delete {user.name}'s account, it will be removed from the company and all of associated teams.
                                                    <div className="mt-2 pt-2 border-top d-flex justify-content-end">
                                                        <button type="button" className="btn btn-secondary btn-sm rounded-pill px-3" onClick={ () => handleMemberDelete( user.id ) }>
                                                            {isSaving && currentUser === user.id &&
                                                                <div className="spinner-border spinner-border-sm" role="status">
                                                                    <span className="visually-hidden">Loading...</span>
                                                                </div>
                                                            }
                                                            {currentUser !== user.id &&
                                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                                            }
                                                            <span className="ps-2">{translation("remove_member")}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        
                                        {canUserEdit && user?.no_of_logins && user?.no_of_logins > 0 &&
                                            <span className="position-absolute bg-halite-blue text-white py-1 rounded-pill px-3 font-size-medium" style={{ right: "10px", top: "10px" }}>Logins: { user?.no_of_logins || 0 }</span>
                                        }
                                        
                                    </div>

                                    
                                    <div className="card-footer py-3 d-flex flex-column justify-content-center">
                                        {(!deleteConfirmation || currentUser !== user.id) && (canUserEdit) &&
                                            <>
                                                {team_id && team_id === 'edit' &&
                                                    <button type="button" className="btn btn-halite-blue btn-sm rounded-pill px-3 mb-3" onClick={ () => {handleManager(user.is_manager, user.id);} }>
                                                        {isSaving && currentUser === user.id &&
                                                            <div className="spinner-border spinner-border-sm" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        }
                                                        {currentUser !== user.id &&
                                                            <i className="fa fa-trash" aria-hidden="true"></i>
                                                        }
                                                        {user.is_manager && user.is_manager === true &&
                                                            <span className="ps-2">Ta bort från chefer</span>
                                                        }
                                                        {!user.is_manager &&
                                                            <span className="ps-2">Gör chef</span>
                                                        }
                                                    </button>
                                                }
                                                
                                                <button type="button" className="btn btn-secondary btn-sm rounded-pill px-3" onClick={ () => {setDeleteConfirmation(true);setCurrentUser( user.id );} }>
                                                    {isSaving && currentUser === user.id &&
                                                        <div className="spinner-border spinner-border-sm" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    }
                                                    {currentUser !== user.id &&
                                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                                    }
                                                    <span className="ps-2">{translation("remove_member")}</span>
                                                </button>
                                            </>
                                        }
                                    </div>
                                    
                                    
                                </div>
                            </div>
                        );
                    }) }
                </div>
            }

            { props?.membersCount && organizationUsers && props?.membersCount > organizationUsers.length && !hideLoadMore &&
                
                <div className="row mt-4">
                    <div className="col-12 pb-4 pb-lg-5">
                        <div className="d-flex justify-content-center">
                            <button type="button" className="btn btn-primary text-white rounded-pill" onClick={() => handleLoadMore()}>
                                <span className="pe-2">Ladda mer</span>

                                {isSaving &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                }

                                {!isSaving &&
                                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            }

        </div>
    );
};

export default OrganizationMembers;
